exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.tab-company__tagline[data-v-395d97e4] {\n  margin-top: 22px;\n}\n.avatarImage[data-v-395d97e4] {\n  max-width: 100%;\n}\ntextarea[data-v-395d97e4] {\n  min-height: 77px;\n}\n.error[data-v-395d97e4] {\n  min-height: 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-395d97e4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/settings/TabCompany.vue
// module id = 2529
// module chunks = 0